import { useRef, useState } from "react";
import { calculateDateFromTrialPeriodFormat, validations } from "../../../constants";
import { CardElement, useRecurly } from "@recurly/react-recurly";
import CustomButton from "../../../common/CustomButton";
import toast from "react-hot-toast";

function PBCardDetails({ type = "add", selectedPlan = null, callback = () => {} }) {
    const formRef = useRef();
    const recurly = useRecurly();
    // ===================== Card Details
    const [firstName, setFirstName] = useState("");
    const [firstNameError, setFirstNameError] = useState("");
    const [lastName, setLastName] = useState("");
    const [lastNameError, setLastNameError] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [postalCodeError, setPostalCodeError] = useState("");
    const [isCardValid, setIsCardValid] = useState(false);

    const [rceFocus, setRCEFocus] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();

        const toastId = toast.loading((type == "add" ? "Creating purchase..." : "Updating Card Details..."));

        recurly.token(formRef.current, async (err, token) => {
            callback({
                err: err,
                token: token,
                toastId: toastId,
                formDetails: {
                    firstName: firstName,
                    lastName: lastName,
                    postalCode: postalCode,
                },
            });
        });
    };

    const onBlurNameInput = async (e, type) => {
        e.preventDefault();

        let val = e.target.value;

        let name = val;
        let validation = "first" ? validations.firstnameValidation : validations.lastnameValidation;
        let lengthValidation = "first" ? validations.firstNameLengthValidation : validations.lastNameLengthValidation;
        let setNameError = type == "first" ? setFirstNameError : setLastNameError;
        let setName = type == "first" ? setFirstName : setLastName;

        setName(val);

        if (name.trim() == "") {
            setNameError(validation);
        } else if (name.trim().length < 2) {
            setNameError(lengthValidation);
        } else if (!/^[a-zA-Z\s]*$/.test(name)) {
            setNameError("Name must not contain numbers and special characters");
        } else {
            setNameError("");
        }
    };

    const onBlurPostalCode = async (e) => {
        e.preventDefault();

        let val = e.target.value;
        setPostalCode(val);

        if (val.trim() == "") {
            setPostalCodeError(validations.postalcodeValidation);
        } else if (val.trim().length < 5) {
            setPostalCodeError(validations.postalcodeLengthValidation);
        } else {
            setPostalCodeError("");
        }
    };

    const activeButton = !firstNameError && !lastNameError && !postalCodeError && isCardValid && firstName != "" && lastName != "" && postalCode != "";
    let trialEnd = calculateDateFromTrialPeriodFormat(selectedPlan?.trial_length, selectedPlan?.trial_unit);

    return (
        <div className="card-area-details">
            {type == "add" ? <h5>SUBSCRIBE WITH CREDIT CARD</h5> : <h5>UPDATE CARD DETAILS</h5>}
            <form
                onSubmit={(e) => {
                    onSubmit(e);
                }}
                ref={formRef}
            >
                <div className="card-inpts name-inputs">
                    <input
                        className="card-det h5 g-outline-orange"
                        data-recurly="first_name"
                        placeholder="First Name"
                        onChange={(e) => {
                            onBlurNameInput(e, "first");
                        }}
                        value={firstName}
                        style={{
                            borderColor: firstNameError == "" ? "lightgrey" : "red",
                        }}
                    />

                    <input
                        className="card-det h5 g-outline-orange"
                        data-recurly="last_name"
                        placeholder="Last Name"
                        onChange={(e) => {
                            onBlurNameInput(e, "last");
                        }}
                        value={lastName}
                        style={{
                            borderColor: lastNameError == "" ? "lightgrey" : "red",
                        }}
                    />
                </div>
                <CardElement
                    className={"card-det " + (rceFocus ? "g-outline-orange" : "")}
                    onChange={(e) => {
                        setIsCardValid(e.valid);
                    }}
                    style={{
                        fontSize: "16px",
                        fontWeight: 900,
                        // fontColor: "#80808097",
                        placeholder: {
                            color: "#80808096 !important",
                        },
                    }}
                    onFocus={() => {
                        setRCEFocus(true);
                    }}
                    onBlur={() => {
                        setRCEFocus(false);
                    }}
                />
                <div className="card-inpts postal-input">
                    <input
                        data-recurly="postal_code"
                        placeholder="Postal Code"
                        value={postalCode}
                        className="card-det h5 g-outline-orange"
                        maxLength={10}
                        onChange={(e) => {
                            onBlurPostalCode(e);
                        }}
                        style={{
                            borderColor: postalCodeError == "" ? "lightgrey" : "red",
                        }}
                    />
                </div>
                <h6 style={{marginTop: "5px"}}>Secured by Stripe</h6>

                {selectedPlan && (
                    <>
                        <div className="plan-trial-description">
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <h5>{selectedPlan?.trial_length > 0 ? "AFTER TRIAL ENDS" : "YOU WILL BE CHARGED"}:</h5>
                                <h5>${selectedPlan?.amount} USD</h5>
                            </div>
                            <p>
                                {selectedPlan?.trial_length > 0 && (
                                    <>
                                        First {selectedPlan?.trial_length} {selectedPlan?.trial_unit} are free, cancel anytime.
                                        <br />
                                    </>
                                )}
                                Billed every {`${selectedPlan?.interval_length == 12 ? "12 months" : "month"}`} from {trialEnd}
                            </p>
                        </div>
                    </>
                )}

                <button disabled={!activeButton} className={"primary-button " + (activeButton ? "active" : "") + (!activeButton ? "" : " act")} style={type == "add" ? {} : { marginTop: "20px" }}>
                    {type == "add" ? "START FREE TRIAL" : "UPDATE"}
                </button>
            </form>
        </div>
    );
}

export default PBCardDetails;
